<donut-button class="w-320 red inv" v-if="program.id" @click="openDeactivateWarningModal">Deactivate {{ program.program_name }}</donut-button>